<script>
import NextButton from 'dashboard/components-next/button/Button.vue';

const CHANNEL_TYPES = ['telegram', 'vk', 'whatsapp', 'max', 'phone', 'email'];

export default {
  name: 'SocialChannelsInput',
  components: { NextButton },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  computed: {
    channels() {
      return this.modelValue;
    },
    typeOptions() {
      return CHANNEL_TYPES.map(type => ({
        value: type,
        label: this.$t(
          `INBOX_MGMT.ADD.WEBSITE_CHANNEL.SOCIAL_CHANNELS.TYPES.${type.toUpperCase()}`
        ),
      }));
    },
  },
  methods: {
    emitChannels(channels) {
      this.$emit('update:modelValue', channels);
    },
    updateField(index, field, value) {
      const channels = this.channels.map((channel, i) =>
        i === index ? { ...channel, [field]: value } : channel
      );
      this.emitChannels(channels);
    },
    addChannel() {
      this.emitChannels([
        ...this.channels,
        { type: 'telegram', label: '', value: '' },
      ]);
    },
    removeChannel(index) {
      this.emitChannels(this.channels.filter((_, i) => i !== index));
    },
  },
};
</script>

<template>
  <div class="pb-4">
    <label class="block mb-1">
      {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.SOCIAL_CHANNELS.LABEL') }}
    </label>
    <p class="mb-2 text-sm not-italic text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.SOCIAL_CHANNELS.HELP_TEXT') }}
    </p>

    <div
      v-for="(channel, index) in channels"
      :key="index"
      class="flex flex-wrap items-start gap-2 mb-2"
    >
      <select
        :value="channel.type"
        class="!mb-0 w-32"
        @change="updateField(index, 'type', $event.target.value)"
      >
        <option v-for="opt in typeOptions" :key="opt.value" :value="opt.value">
          {{ opt.label }}
        </option>
      </select>
      <input
        :value="channel.value"
        type="text"
        class="!mb-0 flex-1 min-w-[12rem]"
        :placeholder="
          $t(
            'INBOX_MGMT.ADD.WEBSITE_CHANNEL.SOCIAL_CHANNELS.VALUE_PLACEHOLDER'
          )
        "
        @input="updateField(index, 'value', $event.target.value)"
      />
      <input
        :value="channel.label"
        type="text"
        class="!mb-0 flex-1 min-w-[10rem]"
        :placeholder="
          $t(
            'INBOX_MGMT.ADD.WEBSITE_CHANNEL.SOCIAL_CHANNELS.LABEL_PLACEHOLDER'
          )
        "
        @input="updateField(index, 'label', $event.target.value)"
      />
      <NextButton
        variant="ghost"
        color="slate"
        size="sm"
        icon="i-lucide-trash-2"
        type="button"
        class="mt-1"
        :title="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.SOCIAL_CHANNELS.REMOVE')"
        @click="removeChannel(index)"
      />
    </div>

    <NextButton
      variant="faded"
      color="blue"
      size="sm"
      icon="i-lucide-plus"
      type="button"
      class="mt-1"
      :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.SOCIAL_CHANNELS.ADD')"
      @click="addChannel"
    />
  </div>
</template>
